import aboutUs from './aboutUs';
import authentication from './authentication';
import isItalistLegitimate from './isItalistLegitimate';
import cart from './cart';
import contest from './contest';
import charitableGiving from './charitableGiving';
import contactUs from './contactUs';
import customerService from './customerService';
import designer from './designer';
import designerList from './designerList';
import ipForm from './ipForm';
import main from './main';
import ourPromise from './ourPromise';
import press from './press';
import privacy from './privacy';
import productDetail from './productDetail';
import productList from './productList/productList';
import resetMyPassword from './resetMyPassword';
import reviews from './reviews';
import terms from './terms';

export default {
  aboutUs,
  authentication,
  cart,
  charitableGiving,
  contactUs,
  contest,
  customerService,
  designer,
  designerList,
  ipForm,
  isItalistLegitimate,
  main,
  ourPromise,
  press,
  privacy,
  productDetail,
  productList,
  resetMyPassword,
  reviews,
  terms,
};
